// import logo from './logo.svg';
import { HelmetProvider } from 'react-helmet-async';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import '../src/styles/principal.min.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OPilates from "./pages/O-pilates";
import Beneficios from "./pages/Beneficios";
import Equipamentos from "./pages/Equipamentos";
import EquipamentosCadillac from "./pages/EquipamentosCadillac";
import EquipamentosReformer from "./pages/EquipamentosReformer";
import EquipamentosBarrel from "./pages/EquipamentosBarrel";
import EquipamentosChair from "./pages/EquipamentosChair";
import Planos from "./pages/Planos";
import Contato from "./pages/Contato";
import NotFound from './pages/NotFound';



function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/o-pilates" element={<OPilates />} />
            <Route path="/o-que-e-pilates.html" element={<OPilates />} />
            <Route path="/beneficios" element={<Beneficios />} />
            <Route path="/equipamentos" element={<Equipamentos />} />
            <Route path="/equipamentos/cadillac" element={<EquipamentosCadillac />} />
            <Route path="/equipamentos/reformer" element={<EquipamentosReformer />} />
            <Route path="/equipamentos/barrel" element={<EquipamentosBarrel />} />
            <Route path="/equipamentos/chair" element={<EquipamentosChair />} />
            <Route path="/planos" element={<Planos />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        <Footer />
      </BrowserRouter>
    </HelmetProvider>  
  );
}

export default App;
